/* eslint-disable no-param-reassign, no-underscore-dangle -- window consent globals use vendor-prefixed names */
import {
    ONE_TRUST_PERFORMANCE_GROUP,
    ONE_TRUST_TARGETING_GROUP
} from './oneTrustCategories';
import { revokeSegment } from './segmentConsent';

export function hasOneTrustGroup(activeGroups, groupId) {
    return Boolean(activeGroups && activeGroups.includes(groupId));
}

export function getConsentFlags(activeGroups) {
    return {
        performanceAllowed: hasOneTrustGroup(activeGroups, ONE_TRUST_PERFORMANCE_GROUP),
        targetingAllowed: hasOneTrustGroup(activeGroups, ONE_TRUST_TARGETING_GROUP)
    };
}

export function buildOneTrustDataLayerEvent(activeGroups) {
    const { performanceAllowed, targetingAllowed } = getConsentFlags(activeGroups);

    return {
        event: 'OneTrustGroupsUpdated',
        analyticsConsent: performanceAllowed ? 'granted' : 'denied',
        adsConsent: targetingAllowed ? 'granted' : 'denied'
    };
}

export function invokeConsentInitializer(win, initializerName) {
    const init = win[initializerName];

    if (typeof init === 'function') {
        init();
        win[initializerName] = null;
    }
}

export function applyPerformanceConsent(win, performanceAllowed) {
    if (!performanceAllowed) {
        return;
    }

    invokeConsentInitializer(win, 'initSegment');
    invokeConsentInitializer(win, 'initGoogleTag');
    invokeConsentInitializer(win, 'initGoogleTagManager');
    invokeConsentInitializer(win, 'initHotjar');
}

export function applyTargetingConsent(win, targetingAllowed) {
    if (!targetingAllowed) {
        return;
    }

    const queued = (win._fbqConsentQueue || []).slice();
    win.fbq = null;
    win._fbq = null;
    win._fbqConsentQueue = null;
    invokeConsentInitializer(win, 'initFbPixel');
    queued.forEach(function replayQueuedFbqCall(args) {
        win.fbq.apply(null, args);
    });
}

export function applyOneTrustConsent(win) {
    const activeGroups = win.OnetrustActiveGroups;
    const { performanceAllowed, targetingAllowed } = getConsentFlags(activeGroups);

    win.dataLayer = win.dataLayer || [];
    win.dataLayer.push(buildOneTrustDataLayerEvent(activeGroups));

    if (performanceAllowed) {
        applyPerformanceConsent(win, performanceAllowed);
    } else {
        revokeSegment(win);
    }

    applyTargetingConsent(win, targetingAllowed);
}
